import { default as PrimativeSkeleton } from "react-loading-skeleton";
import { CSS } from "@stitches/react";
import { styled } from "src/ccl/stitches";

import "react-loading-skeleton/dist/skeleton.css";

const StyledSkeleton = styled(PrimativeSkeleton);

type SkeletonProps = {
  css?: CSS;
  height?: number;
  width?: number;
};

export const Skeleton = (props: SkeletonProps) => <StyledSkeleton {...props} />;
